// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-menu{font-size:32px;height:32px;width:32px;display:block;margin:0 auto 6px}.icon-submenu{font-size:18px}.triangle{position:absolute;width:0;height:0;right:0;bottom:0;border-color:transparent transparent #10b981;border-style:solid;border-width:0 0 30px 30px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
